import { memo } from "react";
import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { FLAT_RATE_PLANS, flatRatePlanNames } from "@common/flatRateBilling";
import { Tag } from "@design-system/Tag/Tag";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import type { ApplyCloseTemplateEntitySelectionRow } from "../applyCloseTemplateEntitySelection.types";

export const ApplyCloseEntityPlanCell = memo(
    ({
        row,
        getValue,
    }: CellContext<
        ViewTableFeatures,
        ApplyCloseTemplateEntitySelectionRow,
        FLAT_RATE_PLANS | null | undefined
    >) => {
        if (!row.original.isClientRow) {
            return <ViewTableCell />;
        }

        const value = getValue();

        if (!value) {
            return (
                <ViewTableCell>
                    <span aria-label="No plan">-</span>
                </ViewTableCell>
            );
        }

        const planName = flatRatePlanNames[value] ?? "Custom";

        return (
            <ViewTableCell>
                <Tag color="neutral" outline>
                    {planName}
                </Tag>
            </ViewTableCell>
        );
    },
);

ApplyCloseEntityPlanCell.displayName = "ApplyCloseEntityPlanCell";
